/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import i18n from "./i18n";
import React from "react";
import { I18nextProvider } from "react-i18next";
// import { createRoot } from "react-dom/client";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import ScrollToTop from "./scrollToTop";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

// Get root DOM element
const container = document.getElementById("root");

// Create React 18 root
const root = ReactDOM.createRoot(container);

// Render app
root.render(
  // <React.StrictMode>
  <I18nextProvider i18n={i18n}>
    {/* Set store provider */}
    <Provider store={store}>
      <DndProvider backend={HTML5Backend}>
        {/* Views routing initialized */}
        <BrowserRouter>
          <ScrollToTop />
          <App />
        </BrowserRouter>
      </DndProvider>
    </Provider>
  </I18nextProvider>,
  // </React.StrictMode>
);

// Optional: Unregister service worker
serviceWorker.unregister();
